export class KeypadControlsEvents {
    public static readonly TOTAL_BET_CHANGED: symbol = Symbol('TOTAL_BET_CHANGED');
    public static readonly AUTOPLAY_CLICKED: symbol = Symbol('AUTOPLAY_CLICKED');
    public static readonly INFO_CLICKED: symbol = Symbol('INFO_CLICKED');
    public static readonly HOME_BUTTON_CLICKED: symbol = Symbol('HOME_BUTTON_CLICKED');
    public static readonly TURBO_BUTTON_CLICKED: symbol = Symbol('TURBO_BUTTON_CLICKED');
    public static readonly TOGGLE_TURBO_BUTTON: symbol = Symbol('TOGGLE_TURBO_BUTTON');
    public static readonly UPDATE_KEYPAD: symbol = Symbol('UPDATE_KEYPAD');
}
